const initialState = {
  tbtSigned: null,
  loading: false,
  error: null,
  signing: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case 'TBT_SIGNING_MODAL_FETCH_REQUEST':
      return {
        ...state,
        loading: true,
        error: null,
      };

    case 'TBT_SIGNING_MODAL_FETCH_SUCCESS':
      return {
        ...state,
        loading: false,
        tbtSigned: {
          ...action.payload.signed_record,
          toolbox_talk_document: action.payload.document,
          subcontractor: action.payload.subcontractor,
          html_content: action.payload.html_content,
          document_view_url: action.payload.document_view_url,
          signed: action.payload.already_signed,
          status: action.payload.status,
        },
        error: null,
      };

    case 'TBT_SIGNING_MODAL_FETCH_FAILURE':
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case 'TBT_SIGNING_MODAL_SUBMIT_REQUEST':
      return {
        ...state,
        signing: true,
        error: null,
      };

    case 'TBT_SIGNING_MODAL_SUBMIT_SUCCESS':
      return {
        ...state,
        signing: false,
        tbtSigned: {
          ...state.tbtSigned,
          signed: true,
          signed_at: action.payload.signed_at,
        },
      };

    case 'TBT_SIGNING_MODAL_SUBMIT_FAILURE':
      return {
        ...state,
        signing: false,
        error: action.payload,
      };

    case 'TBT_SIGNING_MODAL_RESET':
      return initialState;

    default:
      return state;
  }
};
